<template>

  <t-page>

    <TypeSpotDetailDialog :no-option-add="noOptionAdd" @onSubmit="onTypeSpotDetailDialog"/>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #default="{status}">

        <t-input v-model="form.spotDetailId" hidden/>

        <t-form-card title="Dados Básicos">

          <t-input v-model="form.name" :add-error="error.name" label="Nome" required/>

          <t-input v-model="form.typeSpotDetailId"
                   :options="typeSpotDetailOptions"
                   label="Agrupamento" select required>

            <template #no-options="{search}">
              <b-link @click="addNoOption('modal-type-spot-detail',search)">Cadastrar Tipo</b-link>
            </template>

            <template #input-group-append>
              <t-button title="Adicionar novo agrupamento" @click="openDialogForm('modal-type-spot-detail')"
                        icon-plus/>
            </template>

          </t-input>

          <t-page-form-field-customized
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('page')"
              :primary-key="form.spotDetailId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
              :primary-key-column="fieldKey" foreign-key-column="pageId"
          />

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-card>


        <t-form-card title="Modelos de Ambientes" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllTypeEnvironment" switch>
            Disponibilizar este detalhe a todos os modelos de ambientes?
            <t-help
                title="Você poderá especificar quais os modelos de ambientes podem utilizar este detalhe, basta desmarcar esta opção e selecionar os modelos de ambientes desejados."/>
          </b-form-checkbox>

          <div v-show="!form.availableAllTypeEnvironment" class="mt-3 ml-3">

            <small>Selecione os modelos de ambientes desejados</small>

            <b-form-checkbox class="ml-3" v-for="item in typeEnvironmentOptions" :key="item.value"
                             :checked="form.typeEnvironments.find(a => a.typeEnvironmentId === item.value) != null"
                             @change="addTypeEnvironmentSelected($event,item.value)">
              {{ item.text }}
            </b-form-checkbox>


          </div>

        </t-form-card>


      </template>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import typeEnvironmentService from "@/services/modules/place/TypeEnvironment.service";
import ui from "@/assets/scripts/ui";
import TypeSpotDetailDialog from "@/views/modules/place/TypeSpotDetailDialog";
import typeSpotDetailService from "@/services/modules/place/TypeSpotDetail.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'SpotDetailForm',
  components: {TypeSpotDetailDialog},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "spotDetailId",
      form: {
        spotDetailId: 0,
        spotDetailNumber: 0,
        name: "",
        note: "",
        availableAllTypeEnvironment: true,
        typeSpotDetailId: 0,
        typeEnvironments: [],
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeSpotDetailOptions: [],
      typeEnvironmentOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await typeEnvironmentService.selectList().then((list) => {
        this.typeEnvironmentOptions = list

        for (let item of this.typeEnvironmentOptions) {
          item.checked = false
        }

      }).catch(error => this.responseError(error))


      await typeSpotDetailService.selectList().then((list) => {
        this.typeSpotDetailOptions = list
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      if (!this.form.availableAllTypeEnvironment && this.form.typeEnvironments.length === 0) {
        ui.msgError(this, "Você marcou a opção de especificar modelos de ambientes para este detalhe, porém não selecionou nenhum tipo de ambiente. Desmarque a opção ou selecione pelo menos 1(um) tipo de ambiente antes de continuar.")
      } else {
        await this.setSendingDefault()
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    addTypeEnvironmentSelected(checked, id) {

      if (checked) {
        //Adicionar
        const el = this.form.typeEnvironments.find(a => a.typeEnvironmentId === id)
        if (el == null)
          this.form.typeEnvironments.push({typeEnvironmentId: id})
      } else {
        //Remover
        const indexRemove = this.form.typeEnvironments.findIndex(a => a.typeEnvironmentId === id)

        if (indexRemove >= 0)
          this.form.typeEnvironments.splice(indexRemove, 1)

      }

    },

    selectGroupTypeEnvironment(checked, array) {

      for (const el of array) {
        this.addTypeEnvironmentSelected(checked, el.value)
      }

    },

    onTypeSpotDetailDialog(itemInserted) {

      this.form.typeSpotDetailId = itemInserted.value
      this.typeSpotDetailOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

